'use strict';

var React = require('react');

var SvgPersonalizedTextIcon = function SvgPersonalizedTextIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 4a2.75 2.75 0 0 0-2.75 2.75v1.94l-.78.78a.75.75 0 0 0 0 1.06l.78.78v1.94a2.75 2.75 0 0 0 2.75 2.75h.25a.75.75 0 0 0 0-1.5h-.25c-.69 0-1.25-.56-1.25-1.25v-2.25a.75.75 0 0 0-.22-.53l-.47-.47.47-.47a.75.75 0 0 0 .22-.53v-2.25c0-.69.56-1.25 1.25-1.25h.25a.75.75 0 0 0 0-1.5h-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 16a2.75 2.75 0 0 0 2.75-2.75v-1.94l.78-.78a.75.75 0 0 0 0-1.06l-.78-.78v-1.94a2.75 2.75 0 0 0-2.75-2.75h-.25a.75.75 0 0 0 0 1.5h.25c.69 0 1.25.56 1.25 1.25v2.25c0 .199.079.39.22.53l.47.47-.47.47a.75.75 0 0 0-.22.53v2.25c0 .69-.56 1.25-1.25 1.25h-.25a.75.75 0 0 0 0 1.5h.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.75 7.75a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0Zm2.25-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.163 13.368a2.069 2.069 0 0 1 3.674 0l.247.477a.75.75 0 1 0 1.332-.69l-.246-.476a3.569 3.569 0 0 0-6.34 0l-.246.476a.75.75 0 1 0 1.332.69l.247-.477Z"
  }));
};
SvgPersonalizedTextIcon.displayName = "PersonalizedTextIcon";

exports.SvgPersonalizedTextIcon = SvgPersonalizedTextIcon;
